import { createRouter as _createRouter, createWebHashHistory } from 'vue-router'
import I18n from '@/language/i18n.ts'

// const { t,locale } = useI18n()
// const pages = import.meta.glob('../src/pages/**/*.vue')
// const routes = Object.keys(pages).map((path)=>{
//   let name = path.match(/\/pages(.*)\.vue$/)[1].toLowerCase();
//   if(name.substring(name.length - 5) == 'index'){
//     name = name.slice(0, -5);//去掉最后的index
//   }
//   return {
//     path: name === '/home' ? '/': name,
//     component: pages[path]
//   }
// })

const routes = [
  {
    path: '/',
    name: 'PageView',
    redirect: '/home',
    component: () => import('@/view/PageView.vue'),
    meta:{
      keepAlive: true,
    },
    children: [
      {
        path: '/',
        name: 'Home',
        component: () => import('@/view/HomePage.vue'),
        meta: {
          title: 'HomeTitle',
          keepAlive: true,
        },
      },
      {
        path: '/Download',
        name: 'Download',
        component: () => import('@/view/Download.vue'),
        meta: {
          title: 'Download',
          keepAlive: true,
        },
      },
      {
        path: '/AboutUs',
        name: 'AboutUs',
        component: () => import('@/view/AboutUs.vue'),
        meta: {
          title: 'AboutUs',
          keepAlive: true,
        },
      },
      {
        path: '/News',
        name: 'News',
        component: () => import('@/view/News.vue'),
        meta: {
          title: 'News',
          keepAlive: true,
        },
      },
      {
        path: '/NewsDetails',
        name: 'NewsDetails',
        component: () => import('@/view/NewsDetails.vue'),
        meta: {
          title: 'NewsDetails',
          keepAlive: true,
        },
      },
      {
        path: '/Company',
        name: 'Company',
        component: () => import('@/view/Company.vue'),
        meta: {
          title: 'Company',
          keepAlive: true,
        },
      },
      {
        path: '/AndroidProcess',
        name: 'AndroidProcess',
        component: () => import('@/view/AndroidProcess.vue'),
        meta: {
          title: 'AndroidProcess',
          keepAlive: true,
        },
      },
      {
        path: '/IOSProcess',
        name: 'IOSProcess',
        component: () => import('@/view/IOSProcess.vue'),
        meta: {
          title: 'IOSProcess',
          keepAlive: true,
        },
      },
    ]
  }
]


export function createRouter() {
  const router = _createRouter({
    history: createWebHashHistory(),
    routes
  })

  // 添加全局导航守卫
  router.beforeEach((to, from, next) => {
    window.scrollTo(0, 0); // 将滚动位置设置为顶部
    const title = to.meta.title ? I18n.global.t(`message.title.${to.meta.title}`) : I18n.global.t(`message.title.HomeTitle`);
    document.title = title; // 设置页面标题
    // window.document.title = to.meta.title
    next();
  });

  return router;
}

